import React, { forwardRef, useEffect } from 'react';
import  {useState} from "react";
import moment from 'moment';
import 'moment/locale/pt-br';
import DatePicker,{ registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import br from 'date-fns/locale/pt-BR';
registerLocale('br', br);

const DateField = forwardRef((props, ref) => {
    let dateValue  = '';
    if(props.value && props.value != ''){
        dateValue = moment(props.value).toDate();
    }

    let [value,updateValue] = useState(dateValue);
    let className = "form-control";

    const handleChange = element => {
     let value = null;
     if(element !== null && moment(element).isValid()){
        value = moment(element).format("YYYY-MM-DD") 
     }
      const target = {
        name:props.name,
        type: 'date',
        value
      }
      updateValue(element);
      props.onChange({target:target}, props.item);
    };

    if(props.error){
        className+=" is-invalid";
    }

    useEffect(() => {
        if(props.value && props.value != ''){
            dateValue = moment(props.value).toDate();
        }
        updateValue(dateValue)
    }, [props.value]);

    const parsedDate = moment(value, "DD/MM/YYYY", true);
    const isDateValid = parsedDate.isValid();

    return (
        <div ref={ref}>
            {!props.readOnly && (
                <div>
                    <DatePicker
                        id={'id_'+props.name} 
                        name={props.name}
                        selected={value}
                        onChange={handleChange}
                        locale="br"
                        dateFormat="dd/MM/yyyy"
                        strictParsing
                        className={className}
                        autoFocus={props.autoFocus?true:false}
                    />
                </div>
            )}

            {props.readOnly && (
                <span>{isDateValid ? moment(value).format("DD/MM/YYYY") : ''}</span>
            )}
 
            {props.error && (
                <span 
                    class="error invalid-feedback" 
                    style={{display:'inline'}}>
                        {props.error}
                </span>
            )}
        </div>
        
    );
})
export default DateField;